/**
 * Format a YYYY-MM-DD ISO date string as a long-form en-NZ date.
 *
 * Examples:
 *   '2026-03-04'              → '4 March 2026'
 *   '2026-03-04T00:00:00Z'   → '4 March 2026'  (TZ suffix ignored)
 *   null / undefined / ''    → '—'
 *   'not-a-date'             → 'not-a-date'     (pass-through)
 *
 * Parsing is done component-by-component to avoid UTC-to-local TZ drift
 * that occurs when Date.parse() treats bare YYYY-MM-DD as UTC midnight.
 */

const ISO_DATE_RE = /^(\d{4})-(\d{2})-(\d{2})/

export function isIsoDateString(value: unknown): boolean {
  return typeof value === 'string' && ISO_DATE_RE.test(value)
}

const LONG_DATE_FORMAT = new Intl.DateTimeFormat('en-NZ', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
})

export function formatLongDateNZ(value: unknown): string {
  if (value === null || value === undefined || value === '') return '—'

  const s = String(value)
  const m = ISO_DATE_RE.exec(s)
  if (!m) return s

  const year = Number(m[1])
  const month = Number(m[2]) // 1-based
  const day = Number(m[3])

  // Construct as local date (not UTC) to avoid TZ drift
  const d = new Date(year, month - 1, day)
  return LONG_DATE_FORMAT.format(d)
}
